export interface ScacBookingEligibleRequest {
  loadId: string;
  scac: string;
}
